import React from 'react';
import { Container,Row,Col } from 'react-bootstrap'
import {toast} from 'react-toastify'

import { db } from '../firebase.config';
import {doc , deleteDoc} from 'firebase/firestore'

import useGetData from '../custom-hooks/useGetData';


const BoardAllProducts = () => {

    const {data:productsData,loading} = useGetData('products')

    const deleteProduct = async(id)=>{
        await deleteDoc(doc(db,'products',id))
        toast.success('Deleted')
    }
    

    return (
        <section>
            <Container>
                <Row>
                    <Col lg='12'>
                        <table className='table'>

                            <thead>
                                <tr>
                                    <th>Image</th>
                                    <th>Title</th>
                                    <th>Category</th>
                                    <th>Price</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {
                                    loading ? <tr><td className='pe-0 pt-3 text-center fs-2 fw-bold border-0'>Loading....</td></tr> :
                                    
                                        productsData.map((items,index)=>{
                                            return(
                                                <tr key={index}>
                                                    <td><img src={items.imgUrl} alt="product" /></td>
                                                    <td>{items.title}</td>
                                                    <td>{items.category}</td>
                                                    <td>${items.price}</td>
                                                    <td><button onClick={()=>{deleteProduct(items.id)}} className='btn btn-danger'>Delete</button></td>
                                                </tr>
                                            )
                                        })
                                    
                                }
                            </tbody>

                        </table>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default BoardAllProducts